import React from 'react'

export const headingType = {
  sub: 'sub',
} as const

interface HeadingProps {
  text: string
  type?: string
  className?: string
}

function Heading({ text, type = 'heading', className = '' }: HeadingProps) {
  switch (type) {
  case headingType.sub:
    return <h3 className={`text-base font-semibold ${className}`}>{text}</h3>
  default:
    return <h1 className={`text-2xl font-bold leading-tight text-gray-900 ${className}`}>{text}</h1>
  }
}

export default Heading
